import { HTMLControl } from '../controls/html_control.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';

class TrackEditToolbar extends HTMLControl {
  isCutTrackOn() {
    return this.cutTrackButton.hasAttribute('pressed');
  }

  isDeleteTrackOn() {
    return this.deleteTrackButton.hasAttribute('pressed');
  }

  cutTrackOff() {
    this.cutTrackButton.removeAttribute('pressed');
  }

  deleteTrackOff() {
    this.deleteTrackButton.removeAttribute('pressed');
  }

  initialize() {
    super.initialize();

    listenToEvent(this.cutTrackButton, 'click', () => {
      this.cutTrackButton.hasAttribute('pressed')
        ? this.cutTrackButton.removeAttribute('pressed')
        : this.cutTrackButton.setAttribute('pressed', 'true');
    });
    listenToEvent(this.deleteTrackButton, 'click', () => {
      this.dispatchEvent(new Event('trackdelete'));
    });
  }

  static markup = `
    <div id='map-cut-track-button'
         class='map-bar-button button'>
      <img src='/images/map-button-cut.png'
           title='Cut a track'>
    </div>
    <div id='map-delete-track-button'
         class='map-bar-button button'>
      <img src='/images/map-button-waste.png'
           title='Delete a track'>
    </div>
  `;

  static get selectors() {
    return Object.assign({}, super.selectors, {
      CutTrackButton: `#map-cut-track-button`,
      DeleteTrackButton: `#map-delete-track-button`,
    });
  }

  static get elements() {
    return {
      cutTrackButton: this.selectors.CutTrackButton,
      deleteTrackButton: this.selectors.DeleteTrackButton,
    };
  }
}

window.customElements.define('track-edit-toolbar', TrackEditToolbar);

export { TrackEditToolbar };
